<template>
  <div :class="`monitor ${size} ${classes}`">
    <c-img :class="`${size}`" src="img/kb-screen.png" />
    <div :style="screenshotBackgroundStyle" :class="`screenshot-overlay`" />
  </div>
</template>

<script>
export default {
  name: 'ModernMonitor',
  props: {
    screenshotUrl: String,
    classes: {
      type: String,
      default: '',
    },
    size: {
      type: String,
      enum: ['standard', 'large'],
      default: 'standard',
    },
  },
  computed: {
    screenshotBackgroundStyle() {
      return `background: url('${this.screenshotUrl}') #5FCEB2`;
    },
  },
};
</script>

<style lang="scss" scoped="scoped">
.monitor {
  &.standard {
    position: relative;
    width: 300px;
    margin: 0 auto;
    height: 260px;
    img {
      position: absolute;
      width: 300px;
      left: 20px;
      z-index: 1;
      top: 0;
    }
    .screenshot-overlay {
      height: 155px;
      width: 257px;
      background-size: cover !important;
      background-repeat: no-repeat !important;
      position: absolute;
      top: 45px;
      left: 22px;
      background-position: center !important;
    }
  }
  &.large {
    position: relative;
    width: 400px;
    margin: 0 auto;
    img {
      position: absolute;
      width: 400px;
      left: 20px;
      z-index: 1;
      top: 0;
    }
    .screenshot-overlay {
      height: 205px;
      width: 340px;
      background-size: cover !important;
      background-repeat: no-repeat !important;
      position: absolute;
      top: 60px;
      left: 22px;
      background-position: center !important;
    }
  }
  &.loader {
    background: green;
    position: relative;
    width: 400px;
    margin: 0 auto;
    img {
      position: absolute;
      width: 400px;
      left: 20px;
      z-index: 1;
      top: 0;
    }
    .screenshot-overlay {
      height: 205px;
      width: 340px;
      //background-color: green;
      background-size: contain !important;
      background-repeat: no-repeat !important;
      position: absolute;
      top: 60px;
      left: 25px;
      background-position: center !important;
    }
  }
}
</style>
